export const USER_ROLES = {
    EMPLOYEE_LSR: 'employee_lsr',
    USER_MANAGEMENT: 'user_management',
    SYSTEM_SETTINGS: 'system_settings',
    IMPERSONATION_PENSION_DOMAIN: 'impersonation_pension_domain',
    IMPERSONATION_LOAN_DOMAIN: 'impersonation_loan_domain',
    SEND_ELECTRONIC_ID_REQUESTS: 'send_electronic_id_requests',
    VIEW_ALL_ELECTRONIC_ID_REQUESTS: 'view_all_electronic_id_requests',
    UPLOAD_DOCUMENTS: 'upload_documents',
    DOCUMENT_CENTER_SUPERUSER: 'document_center_superuser',
    REGISTER_ICELAND_LOOKUP: 'register_iceland_lookup',
    SEND_INCIDENT_REPORT: 'send_incident_report',
    SEND_TECHNICAL_SUPPORT_REQUESTS: 'send_technical_support_requests',
    SEND_ACCESS_REQUESTS: 'send_access_requests',
    SEND_HOUSING_REQUESTS: 'send_housing_requests',
    SEND_EMPLOYEE_SUPPORT_REQUESTS: 'send_employee_support_request',
    ADMIN_SEND_EMPLOYEE_SUPPORT_REQUESTS: 'admin_send_employee_support_request',
    CURRENCY_REGISTER: 'currency_register',
    OVERVIEW_LOANS: 'overview_loans',
    PENSION_APPLICATIONS: 'pension_applications',
    PENSION_COEFFICIENT_MANAGEMENT: 'pension_coefficient_management',
    CHECK_LOAN_ELIGIBILITY: 'check_loan_eligibility',
    PENSION_CALCULATOR_TEST: 'pension_calculator_test',
    SERVICEUSER_MANAGEMENT: 'service_user_management',
    VIEW_JOB_STATUS_ROLE: 'view_job_status',
    CONFIGS_SUPERUSER_ROLE: 'configs_superuser',
    EDIT_CONFIGS_ROLE: 'edit_configs',
    TRANSLATIONS_SUPERUSER_ROLE: 'translations_superuser',
    EDIT_TRANSLATIONS_ROLE: 'edit_translations',
    REPORTS: 'reports',
    EDIT_OWN_GROUPS: 'edit_own_groups',
    EDIT_SVID_GROUPS: 'edit_svid_groups',
    DOCUMENT_TEMPLATES: 'document_templates',
    DOCUMENT_ACCESS_FILES_WITH_DIVISION: 'document_access_files_with_division',
    EDIT_MORTGAGE_ELIGIBILITY_FORMS: 'edit_mortgage_eligibility_forms',
    DOCUMENT_TEMPLATES_LOCKED_SSNS: 'document_templates_locked_ssns',
    RISK_MANAGEMENT_FME_REPORT: 'risk_management_fme_report',
    APPLICATIONS_MANUAL_STATISTICS_ADMIN: 'applications_manual_statistics_admin',
    APPLICATIONS_MANUAL_STATISTICS: 'applications_manual_statistics',
    TEST_PORTAL_LSR_ROLE: 'test_portal_lsr',
    PENSION_STATE_RESPONSIBILITY_GROUP: 'pension_state_responsibility_group',
    PENSION_INCREASE_CLAIMS: 'pension_increase_claims',
    PENSION_PAYCHECK_RUNS: 'pension_paycheck_runs',
    USER_SELECTOR: 'user_selector',
    EXTERNAL_SYSTEM_LOGS: 'external_system_logs',
    VALIDATION_CHECK_XML_XSD: 'validation_check_xml_xsd',
    PENSION_DIVISION_OF_RULINGS: 'pension_division_of_rulings',
    PENSION_OTHER_FUNDS_APPLICATIONS: 'pension_other_funds_applications',
    AZURE_ENVIRONMENT_RESERVATIONS: 'azure_environment_reservations',
    BAKVORDUR: 'bakvordur',
    BAKVORDUR_ADMIN: 'bakvordur_admin',
    PENSION_INFO: 'pension_info',
};
